import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/shadcn/select'
import { useGetApiCompaniesCurrentEmployeesReportingDoneactionmodules } from '@/api/generated/company-management-user/company-management-user'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Rectangle, Legend } from 'recharts'
import { CHART_COLORS, TAKE_OPTIONS } from './constants'
import { ChartCard } from '../components/ChartCard'
import { ChartTooltip } from '../components/ChartTooltip'
import { FilterRowCharts } from '@/components/common/filters/FilterRowCharts'
import { FilterRowChartItem } from '@/components/common/filters/FilterRowChartItem'
import { LoaderGeneral } from '@/components/common/loaders/LoaderGeneral'

export function ActionModulesDoneChart() {
  const { t } = useTranslation('dashboard')
  const [count, setCount] = useState(5)

  const { data, isFetching, isError } = useGetApiCompaniesCurrentEmployeesReportingDoneactionmodules({ take: count })

  const chartData = (data?.data ?? [])
    .map((item, index) => ({
      name: [item.firstName, item.lastName].filter(Boolean).join(' ') || '—',
      value: item.totalDoneActionModules,
      fill: CHART_COLORS[index % CHART_COLORS.length],
    }))
    .sort((first, second) => second.value - first.value)

  function chart() {
    return (
      <LoaderGeneral isLoading={isFetching} isError={isError} isEmpty={chartData.length === 0} className="h-[260px]">
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={chartData} layout="vertical" margin={{ top: 4, right: 16, bottom: 4, left: 8 }} barCategoryGap="20%">
            <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="var(--border)" />
            <XAxis type="number" allowDecimals={false} tick={{ fontSize: 11, fill: 'var(--muted-foreground)' }} tickLine={false} axisLine={false} />
            <YAxis type="category" dataKey="name" width={120} tick={{ fontSize: 11, fill: 'var(--foreground)' }} tickLine={false} axisLine={false} />
            <Tooltip content={<ChartTooltip valueLabel={t('charts.actionModulesDone.tooltipLabel')} />} cursor={{ fill: 'var(--muted)' }} />
            <Legend formatter={() => t('charts.actionModulesDone.legend')} />
            <Bar
              dataKey="value"
              radius={[0, 4, 4, 0]}
              maxBarSize={22}
              shape={(props: any) => <Rectangle {...props} fill={props.payload.fill} />}
            />
          </BarChart>
        </ResponsiveContainer>
      </LoaderGeneral>
    )
  }

  function controls() {
    return (
      <FilterRowCharts>
        <FilterRowChartItem label={t('charts.filters.count')}>
          <Select value={String(count)} onValueChange={(v) => setCount(Number(v))}>
            <SelectTrigger className="text-sm">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {TAKE_OPTIONS.map((number) => <SelectItem key={number} value={String(number)}>{number}</SelectItem>)}
            </SelectContent>
          </Select>
        </FilterRowChartItem>
      </FilterRowCharts>
    )
  }

  return (
    <ChartCard
      title={t('charts.actionModulesDone.title')}
      chart={chart()}
      controls={controls()}
    />
  )
}
